// extracted by mini-css-extract-plugin
export var starContainer = "StarBadge-module--star-container--3Me-h";
export var price = "StarBadge-module--price--3rRYt";
export var green = "StarBadge-module--green--kgg_r";
export var brown = "StarBadge-module--brown--R0-pA";
export var monthly = "StarBadge-module--monthly--dpZhG";
export var number = "StarBadge-module--number--1yoUu";
export var label = "StarBadge-module--label--2Eebb";
export var littleCost = "StarBadge-module--little-cost--137I_";
export var free = "StarBadge-module--free--1hd3t";